// src/pages/Success.jsx
import React from "react";
import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-white px-6 text-center">
      <h1 className="text-4xl md:text-5xl font-bold mb-4 text-hoverBlue animate-fadeIn">
        🎉 Submission Successful!
      </h1>

      <p className="text-lg md:text-xl mb-6 text-gray-300 animate-slideUp">
        Thank you for getting started with <strong>Project Port</strong> by{" "}
        <strong>Techverra Solutions</strong>.<br />
        We’ve received your details and will start building your portfolio site.
      </p>

      <Link
        to="/"
        className="px-6 py-3 bg-primary hover:bg-buttonHover transition-all duration-200 rounded-full font-semibold text-white shadow-md"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default Success;
